module.exports = __webpack_public_path__ + "static/media/twophone.b27e834f.jpg";